import {
    ADD_STAGE,
    DELETE_STAGE,
    EDIT_STAGE,
    LOAD_STAGE,
  } from '../../actions/boardStage';

  export default function boardStage(state = {}, action) {
      switch (action.type) {
          case ADD_STAGE:
            return Object.assign({}, state, action.payload);
          case DELETE_STAGE:
            return Object.assign({}, state, action.payload);
          case EDIT_STAGE:
            return Object.assign({}, state, action.payload);
          case LOAD_STAGE:
            return Object.assign({}, state, action.payload);
          default:
            return state;
      }
  }


// WEBPACK FOOTER //
// ./src/reducers/boardStage/index.js